export const DEFAULT_NUM_SHARED_ZAPS = 6;
export const APPS_INTEGRATIONS_EAGER_ROUTE_SUFFIX = 'eager/:slug1/:slug2?';
export const APPS_INTEGRATIONS_EAGER_ROUTE_PATH = `apps/integrations/${APPS_INTEGRATIONS_EAGER_ROUTE_SUFFIX}`;
